import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

interface PaymentCheckboxProps {
  checked: boolean;
  onPress: () => void;
  label: string;
  disabled?: boolean;
}

/**
 * Reusable checkbox component for payment forms
 * Used in credit card and ACH forms for "Make default" option
 */
export const PaymentCheckbox: React.FC<PaymentCheckboxProps> = ({
  checked,
  onPress,
  label,
  disabled = false,
}) => {
  return (
    <TouchableOpacity
      style={styles.checkboxRow}
      onPress={onPress}
      activeOpacity={0.7}
      disabled={disabled}
    >
      <View style={styles.checkboxContainer}>
        {checked ? (
          <View style={styles.checkboxSelected}>
            <View style={styles.checkmark} />
          </View>
        ) : (
          <View style={[styles.checkboxUnselected, disabled && styles.checkboxDisabled]} />
        )}
      </View>
      <Text style={[styles.checkboxLabel, disabled && styles.checkboxLabelDisabled]}>
        {label}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  checkboxContainer: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxSelected: {
    width: 16,
    height: 16,
    borderRadius: 4,
    backgroundColor: MARKETPLACE_COLORS.checkboxSelected,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkmark: {
    width: 8,
    height: 6,
    borderLeftWidth: 2,
    borderBottomWidth: 2,
    borderColor: MARKETPLACE_COLORS.textPrimary,
    transform: [{ rotate: '-45deg' }],
    marginTop: -2,
  },
  checkboxUnselected: {
    width: 16,
    height: 16,
    borderRadius: 4,
    backgroundColor: MARKETPLACE_COLORS.checkboxBackground,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.checkboxBorder,
  },
  checkboxDisabled: {
    opacity: 0.5,
  },
  checkboxLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  checkboxLabelDisabled: {
    opacity: 0.5,
  },
});

export default PaymentCheckbox;
